const { z } = require('zod');

const $b = z.boolean();
const $s = z.string();

const $env = z.enum(['development', 'staging', 'production', 'test', 'local']);

const $azureInsights = z.object({
    web: $s,
    native: $s
});

const $brazeConfig = z.object({
    // native-only (app.config.ts @braze/expo-plugin) — optional so web omits them
    androidApiKey: $s.optional(),
    iosApiKey: $s.optional(),
    webApiKey: $s,
    baseUrl: $s.url(),
    enableBrazeIosPush: $b.optional(),
    enableFirebaseCloudMessaging: $b.optional(),
    firebaseCloudMessagingSenderId: $s.optional(),
    sessionTimeout: z.number().optional(),
    enableSdkAuthentication: $b.optional(),
    logLevel: z.number().optional(),
    minimumTriggerIntervalInSeconds: z.number().optional(),
    enableAutomaticLocationCollection: $b.optional(),
    enableGeofences: $b.optional(),
    enableAutomaticGeofenceRequests: $b.optional(),
    dismissModalOnOutsideTap: $b.optional(),
    androidHandlePushDeepLinksAutomatically: $b.optional(),
    androidPushNotificationHtmlRenderingEnabled: $b.optional(),
    androidNotificationAccentColor: $s.optional(),
    androidNotificationLargeIcon: $s.optional(),
    androidNotificationSmallIcon: $s.optional(),
    iosRequestPushPermissionsAutomatically: $b.optional(),
    enableBrazeIosRichPush: $b.optional(),
    enableBrazeIosPushStories: $b.optional(),
    iosPushStoryAppGroup: $s.optional(),
    enableLogging: $b.optional()
});

const $config = z
    .object({
        env: $env,
        appName: $s,
        appSlug: $s,
        expoUid: $s,
        iosBundleId: $s,
        androidPackage: $s,
        applePayMerchandId: $s,
        apiBaseUrl: $s.url(),
        googleServicesAndroid: $s.optional(),
        googleServicesIos: $s.optional(),
        googleTagManagerId: $s.optional(),
        googleOauthClientIdWeb: $s,
        googleOauthClientIdIos: $s,
        googleOauthClientIdAndroid: $s,
        googleOauthiOSUrlScheme: $s.optional(),
        appleOauthClientIdWeb: $s,
        appleOauthRedirectUri: $s.url(),
        hCaptchaSiteKeyWeb: $s,
        hCaptchaSiteKeyNative: $s.optional(),
        justSaladSecretKey: $s.optional(),
        sentryDsnNative: $s.url().optional(),
        sentryDsnWeb: $s.url().optional(),
        sentryEnvironment: $s,
        sentryDebug: $b,
        postHogApiKey: $s,
        iterableApiKey: $s,
        stateStorageKey: $s,
        cloudinaryCloudName: $s,
        e2eTesting: $b,
        useFixtures: $b,
        universalLinkDomains: z.array($s),
        automatedTestKey: $s.optional(),
        oneSignalAppId: $s,
        firebaseCloudMessagingSenderId: $s.optional(),
        brazeConfig: $brazeConfig,
        azureInsights: $azureInsights,
        mapboxApiKeyNative: $s.optional(),
        mapboxApiKeyWeb: $s,
        mixpanelToken: $s,
        roktIosKey: $s.optional(),
        roktIosSecret: $s.optional(),
        roktAndroidKey: $s.optional(),
        roktAndroidSecret: $s.optional(),
        roktWebApiKey: $s.optional(),
        stackadaptOrderNowPixelId: $s.optional(),
        stackadaptPurchasePixelId: $s.optional(),
        iosAppStoreUrl: $s.url().optional(),
        androidPlayStoreUrl: $s.url().optional()
    })
    .strict();

module.exports = {
    $env,
    $config
};
